import React from "react"
import useTranslation from "../../hooks/useTranslation"
import { Html } from "../index"

export const Unsupported = ({ name, Tag = "div", uid }) => {
  const { translate } = useTranslation()

  return <Html content={translate("unsupported.label", { name, uid })} Tag={Tag} />
}
